// Live typing: keep hyphens (including a trailing one while the user is still typing).
export const sanitizeAliasInput = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-{2,}/g, '-')
    .replace(/^-+/, '')
    .slice(0, 48);

// Final form used for API calls: strip leading/trailing hyphens.
export const finalizeAlias = (value) =>
  sanitizeAliasInput(value).replace(/-+$/g, '');

export const isValidAliasFormat = (value) =>
  /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(finalizeAlias(value)) &&
  finalizeAlias(value).length >= 3;
